module.exports = __webpack_public_path__ + "img/cases03-bg.2e69ab37.png";